import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Approve from '@/views/Approve.vue';
import {account} from '@/store/account.module';
import config from '@/config';
import UserLogin from '@/views/User/Login';
import {userService} from "@/services";

Vue.use(Router);

let commonRoutes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/approve-prompt',
    name: 'approve',
    component: Approve
  }
];

let userRoutes = [
  {
    path: '/login',
    name: 'login',
    component: UserLogin
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: UserLogin,
    props: {
      component: 'UserResetPasswordForm'
    }
  }
];

let routes = commonRoutes;
routes = routes.concat(userRoutes);

routes = routes.concat([
  {path: '*', redirect: '/login'}
]);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/reset-password', '/create-password'];
  const authRequired = !publicPages.includes(to.path);
  const defaultAppRedirectPages = ['/login', '/'];
  const isDefaultAppRedirectPage = defaultAppRedirectPages.includes(to.path);

  if (config.defaultAppRedirectEnabled && !userService.getAuthRequestParams() && isDefaultAppRedirectPage) {
    window.location.href = config.defaultAppRedirectUrl
  }

  if (authRequired) {
    account.actions.loggedInRedirect(next);
  } else {
    next();
  }
});

export default router;
